import React from 'react'

import style from './VAC_AlarmPopup.module.scss'

import SvgPopupClose from '@Root/ui/images/alarm/popup_confirm--close.svg'

type Props = {
  popupList?: any
  isHidden: boolean
}

const AlarmPopup: React.FC<Props> = ({ popupList, isHidden }: Props) => {
  return (
    <div className={`dimmed ${style['type_alarm']}`} aria-hidden={isHidden}>
      {Object.entries(popupList).map(([key], i) => (
        <div key={style.alarm_popup + '-' + i} className={`${style['alarm_popup']} ${style['type_confirm']}`}>
          <div className={style.alarm_popup_inner}>
            {popupList[key].title ? <strong className={style.alarm_popup_title}>{popupList[key].title}</strong> : ''}

            {popupList[key].text ? <p className={style.alarm_popup_text}>{popupList[key].text}</p> : ''}
          </div>

          {(function () {
            if (popupList[key].confirmText !== undefined) {
              return (
                <button className={`${style['alarm_popup_button']} ${style['type_confirm']}`} onClick={popupList[key].handleClickConfirm}>
                  {popupList[key].confirmText}
                </button>
              )
            }
          })()}
          {(function () {
            if (popupList[key].closeButton == true) {
              return (
                <button className={`${style['alarm_popup_button']} ${style['type_close']}`} aria-label="닫기" onClick={popupList[key].handleClickClose}>
                  <SvgPopupClose />
                </button>
              )
            }
          })()}
        </div>
      ))}
    </div>
  )
}

export default AlarmPopup
